import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { DsButtonModule, DsLoadingModule, DsMessageModule } from '@bmw-ds/components';

import { FoundCustomer } from '../../../customer/model/found-customer.model';
import { InputFieldComponent } from '../../../form/components/input-field/input-field.component';
import { SearchResultsComponent } from '../../../form/components/search-results/components/search-results/search-results.component';
import { SearchResultMode } from '../../../form/components/search-results/model/search-result-mode.model';
import { useI18n } from '../../../i18n/services/i18n.service';

@Component({
  selector: 'cdf-nsc-customer-search',
  imports: [InputFieldComponent, DsButtonModule, SearchResultsComponent, DsLoadingModule, DsMessageModule],
  template: `
    <form (submit)="onSubmit($event)">
      <div class="container-fluid">
        <div class="row">
          <span id="description" class="text-regular col-auto">{{ i18n('nscSync.description') }}</span>
        </div>
        <div class="row input">
          <cdf-input-field
            class="col-sm-4"
            id="email-input"
            [(model)]="email"
            [placeholder]="i18n('placeholder.email')"
            [disabled]="isLoading()"
          />
          <div class="col">
            <ds-button
              ds-loading
              type="submit"
              [isLoading]="isLoading()"
              (click)="searchNscCustomer.emit()"
              class="col-auto"
              >{{ i18n('nscSync.searchButton') }}</ds-button
            >
          </div>
        </div>
      </div>
    </form>
    @if (searchFailed()) {
      <div class="row failed-search-message">
        <ds-message [messageText]="i18n('searchResults.fullBackendFailure')" tone="critical" />
      </div>
    }
    @if (tooManyResults()) {
      <!-- The NSC Database declines broad queries instead of truncating them, so this is a hint
           to narrow the search rather than a failure. -->
      <div class="row failed-search-message">
        <ds-message [messageText]="i18n('nscSync.tooManyResults')" tone="caution" />
      </div>
    }
    <cdf-search-results
      [searchResults]="foundCustomer()"
      [searchResultMode]="SearchResultMode.MERGE_WITH_NSC"
      (openCustomerProfile)="selectCustomer.emit($event)"
      (createNewCustomer)="createNewNscCustomer.emit()"
    />
  `,
  styleUrl: './nsc-customer-search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NscCustomerSearchComponent {
  protected readonly i18n = useI18n();

  readonly email = model.required<string>();
  readonly isLoading = input.required<boolean>();
  readonly foundCustomer = input.required<FoundCustomer[] | undefined>();
  readonly searchFailed = input(false);
  readonly tooManyResults = input(false);

  readonly selectCustomer = output<FoundCustomer>();
  readonly searchNscCustomer = output();
  readonly createNewNscCustomer = output();

  protected readonly SearchResultMode = SearchResultMode;

  onSubmit(event: Event): void {
    event.preventDefault();
    if (!this.isLoading()) {
      this.searchNscCustomer.emit();
    }
  }
}
